var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSgfMwd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.485,3.515C15.807-1.164,8.194-1.166,3.515,3.515-1.164,8.194-1.164,15.807,3.515,20.486c2.339,2.34,5.412,3.509,8.485,3.509s6.146-1.169,8.485-3.509c4.678-4.679,4.678-12.292,0-16.971Zm-2.157.743l-6.328,6.328-6.328-6.328c1.834-1.501,4.081-2.253,6.328-2.253s4.494.751,6.328,2.253Zm.743,14.814c-3.899,3.897-10.244,3.899-14.143,0-3.66-3.661-3.883-9.475-.671-13.4l7.742,7.742,7.742-7.742c3.211,3.924,2.989,9.74-.671,13.4Z",
    fill: "#1c1c1b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSgfMwd);
export default __webpack_public_path__ + "static/media/icon-sgf-mwd.7d5022755fe3d83b0685224447399e19.svg";
export { ForwardRef as ReactComponent };